import { ColDef, ValueFormatterParams } from 'ag-grid-community';
import { FC, useMemo } from 'react';
import Button from '../../../../components/Button/Button';
import Table from '../../../../components/Table/Table';
import { AddOptionPage, Buttons, StyledH2, StyledP } from '../AddOption.styles';
import { ReviewProps } from './Review.types';
import { Variant } from '../../../../components/Button/Button.types';

const Review: FC<ReviewProps> = ({ reviewResponse, setStep, handleSaveClick, isLoading }) => {

  const defaultColDef = useMemo<ColDef>(() => {
    return {
      wrapHeaderText: false,
      tooltipValueGetter: (params) => params.value,
      filter: true,
      floatingFilter: true,
      tooltipShowDelay: 0
    };
  }, []);

  return (
    <AddOptionPage>
      <StyledH2>Review Subspecs</StyledH2>
      <StyledP>
        For every instance in the table below, a new duplicate subspec will be created based on your target
        characteristic section.
      </StyledP>
      <Table
        rowData={reviewResponse}
        columnDefs={[
          { field: 'specNo', headerName: 'SpecNo', floatingFilter: true, flex: 0.5 },
          { field: 'classDesc', headerName: 'Class', floatingFilter: true, flex: 1 },
          { field: 'baseDesc', headerName: 'Base', floatingFilter: true, flex: 1 },
          { field: 'sizeDesc', headerName: 'Size', floatingFilter: true, flex: 1 },
          { field: 'prodDesc', headerName: 'Prod', floatingFilter: true, flex: 1 },
          { field: 'optionDesc', headerName: 'Option', floatingFilter: true, flex: 1 },
          {
            field: 'rawProdDesc',
            headerName: 'Raw Product',
            floatingFilter: true,
            flex: 1.5,
            valueFormatter: (params: ValueFormatterParams) => params.data.rawProdNo === null ? '' : `${params.data.rawProdDesc} - ${params.data.rawProdNo}`
          },
        ]}
        defaultColDef={defaultColDef}
        showHeader
        headerTitle="Source Subspecs"
        showFooter={true}
        isSizeColumnsToFit={false}
        returnedRecords={reviewResponse.length}
        height={'calc(100vh - 250px)'}
      />
      <Buttons>
        <Button label="Back" variant={Variant.Secondary} onClick={() => setStep(0)} />
        <Button label="Preview" onClick={handleSaveClick} isLoading={isLoading} testId={'previewButton'} />
      </Buttons>
    </AddOptionPage>
  );
};

export default Review;
